module.exports = __webpack_public_path__ + "static/kids-network-logo-5f0daaf5d8a807db168888f33e833833.png";